/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { FlexRow, FlexCol, Heading, Stack, Box, Text } from 'sarsaparilla';
import { gnoment } from 'shared-ui/gnoment';
import FeeEstimate from './FeeEstimate';
import { generateLineItems, sumLineItems } from '../../utils/feeUtils';
import { formatCurrency } from '../../utils/permitUtils';

export default class ReservationDetail extends React.Component {
    static propTypes = {
        permit: PropTypes.shape().isRequired,
        reservations: PropTypes.arrayOf(PropTypes.object).isRequired,
    };
    renderPermitDateText(res) {
        let entryDate = '';
        const startDate = res.start_date;
        if (startDate && gnoment(startDate).isValid()) {
            entryDate = gnoment(startDate).format('LL');
        }
        let exitDate = '';
        let exitDateComponent = null;
        const endDate = res.end_date;
        if (endDate && gnoment(endDate).isValid()) {
            exitDate = gnoment(endDate).format('LL');
            exitDateComponent = (
                <FlexCol>
                    <div>Exit Date</div>
                    <Text color="gray" fontWeight="semibold">
                        {exitDate}
                    </Text>
                </FlexCol>
            );
        }
        return entryDate || exitDateComponent ? (
            <FlexRow>
                {entryDate && (
                    <FlexCol>
                        <div>Entry Date</div>
                        <Text color="gray" fontWeight="semibold">
                            {entryDate}
                        </Text>
                    </FlexCol>
                )}
                {exitDateComponent}
            </FlexRow>
        ) : null;
    }

    renderPermitTimeText(res) {
        const timeslot = res.timeslot;
        if (timeslot && timeslot.start_time && timeslot.end_time) {
            const startTime = gnoment(
                get(timeslot, 'start_time', '00:00:00'),
                'HH:mm:ss'
            ).format('h:mm A');
            const endTime = gnoment(
                get(timeslot, 'end_time', '00:00:00'),
                'HH:mm:ss'
            ).format('h:mm A');

            return (
                <div className="rec-aside-card-item-row">
                    <div className="rec-aside-card-date-wrap">
                        <div className="rec-aside-card-date-title">Start Time</div>
                        <div className="rec-aside-card-date">{startTime}</div>
                    </div>
                    <div className="rec-aside-card-date-wrap">
                        <div className="rec-aside-card-date-title">End Time</div>
                        <div className="rec-aside-card-date">{endTime}</div>
                    </div>
                </div>
            );
        }
        return null;
    }

    renderTotalCost(totalCost) {
        return (
            <div className="rec-order-summary-total per-os-total">
                <FlexRow>
                    <FlexCol className="rec-price-label">Total Cost</FlexCol>
                    <FlexCol className="rec-price-value">
                        <strong>{formatCurrency(totalCost)}</strong>
                    </FlexCol>
                </FlexRow>
            </div>
        );
    }

    render() {
        let totalCost = 0;

        const reservationCards = this.props.reservations.map((res, index) => {
            const division = this.props.permit.divisions[res.division_id];
            const lineItems = generateLineItems(res, division, this.props.permit);
            let prefix = null;
            if (this.props.reservations.length > 1) {
                prefix = `${index + 1}. `;
            }
            totalCost += sumLineItems(lineItems) - get(res, 'amount_paid', 0);
            return (
                <Stack space="xs" key={res.id}>
                    <Box>
                        <Heading headingLevel={2} appearance="h5">
                            {prefix}
                            {division.name}
                        </Heading>
                        {this.props.permit.name}
                    </Box>
                    <Box>{this.renderPermitDateText(res)}</Box>
                    <Box>{this.renderPermitTimeText(res)}</Box>
                    <Box>
                        <FeeEstimate lineItems={lineItems} />
                    </Box>
                </Stack>
            );
        });

        return (
            <>
                <div className="rec-order-summary-item-price">
                    <Stack space="md">{reservationCards}</Stack>
                </div>
                {this.renderTotalCost(totalCost)}
            </>
        );
    }
}
